import Alpine from 'alpinejs';
import { intersect } from '@alpinejs/intersect';
import { Slider } from '@newthink/slider';

Alpine.plugin([intersect, Slider]);

window.Alpine = Alpine;

Alpine.start();
